import React from "react";
import SchoolSignupForm from "../components/SchoolSignupForm";
import AuthWelcomePanel from "../components/auth/AuthWelcomePanel";
import { AuthPageContainer } from "../components/auth/DashboardAuthStyles";

const Login: React.FC = () => {
  return (
    <AuthPageContainer data-testid="login-page">
      <AuthWelcomePanel />
      <SchoolSignupForm initialMode="login" />
    </AuthPageContainer>
  );
};

export default Login;
